import { SUBSCRIPTION_DASHBOARD_API } from 'constants/AppConstants';

export default async (orgId) => {
  try {
    const apiUrl = SUBSCRIPTION_DASHBOARD_API.replace(':orgId', orgId);
    const response = await fetch(apiUrl);
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
